import type {BioIconProps} from './common-types'

export function BrgIconArrowBack({fill, ...attributes}: BioIconProps) {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg" {...attributes}>
      <g id="icon/arrow head/backward">
        <path
          id="arrow_forward_ios"
          d="M9.3611 12.5525L10.3472 11.5664L5.77776 6.99696L10.3472 2.42752L9.3611 1.44141L3.80554 6.99696L9.3611 12.5525Z"
        />
      </g>
    </svg>
  )
}
